import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import { useSettings } from "../../context/SettingsContext";
import NavigationSwiper from "./NavigationSwiper";
import LoadingCircle from "../Common/LoadingCircle";
import DefaultNoPhoto from "../../assets/default-no-photo.jpg";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

const AboutWelcomeNote = () => {
  const { aboutWelcomeNotes, loading } = useSettings();

  if (loading) return <LoadingCircle size="lg" />;
  if (!aboutWelcomeNotes || aboutWelcomeNotes.length === 0) return null;

  return (
    <div className="relative group overflow-visible">
      <Swiper
        key={aboutWelcomeNotes.length} 
        modules={[Navigation, Pagination, Autoplay, EffectFade]}
        effect="fade"
        navigation={{
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        }}
        pagination={{ clickable: true, dynamicBullets: true }}
        autoplay={{ delay: 8000, disableOnInteraction: false }}
        className="rounded-[2.5rem] overflow-hidden shadow-xl border border-slate-100 dark:border-slate-800"
      >
        {aboutWelcomeNotes.map((note) => (
          <SwiperSlide key={note.id}>
            <div className="bg-white dark:bg-slate-900 p-8 md:p-12 flex flex-col md:flex-row gap-10 items-center md:items-start min-h-[500px]">
              
              <div className="w-full md:w-1/3 shrink-0">
                <img
                  src={note.image || DefaultNoPhoto}
                  alt={note.name}
                  onError={(e) => { e.target.src = DefaultNoPhoto; }}
                  className="w-full aspect-[3/4] object-cover rounded-2xl shadow-md"
                />
              </div>

              <div className="flex-1 space-y-6 pt-4 text-left">
                <div>
                  <h3 className="text-blue-600 font-black uppercase tracking-[0.2em] text-xs mb-2">{note.title}</h3>
                  <div className="h-1 w-12 bg-blue-600 rounded-full"></div>
                </div>

                <div className="prose prose-slate dark:prose-invert max-w-none text-slate-600 dark:text-slate-400 leading-relaxed text-sm md:text-base whitespace-pre-line border-b border-slate-100 dark:border-slate-800 pb-8">
                  {note.message}
                </div>

                {/* SATU-SATUNYA TEMPAT NAMA MUNCUL HARUS DI SINI (DI DALAM SLIDE) */}
                <div className="pt-2">
                  <p className="font-bold text-slate-900 dark:text-white text-sm mb-1">Warm regards,</p>
                  <p className="font-black text-blue-700 dark:text-blue-500 uppercase tracking-tight text-lg leading-tight">{note.name}</p>
                  <p className="text-[10px] font-bold text-slate-500 mt-1 uppercase tracking-widest">{note.role}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Navigasi kustom (Hanya berisi tombol panah, tidak boleh ada data nama) */}
      <NavigationSwiper />
    </div>
  );
};

export default AboutWelcomeNote;